import type { MergeField } from './types';

export const MERGE_FIELDS: MergeField[] = [
  { token: '{{primeiro_nome}}', label: 'Primeiro nome', sample: 'Ana' },
  { token: '{{nome}}', label: 'Nome', sample: 'Ana Souza' },
  { token: '{{loja}}', label: 'Loja', sample: 'Sua loja' },
  { token: '{{pontos}}', label: 'Pontos', sample: '1.240' },
];

export function insertToken(current: string, token: string): string {
  if (!current) return token;
  return `${current}${current.endsWith(' ') ? '' : ' '}${token}`;
}

export function applyMerge(text: string, storeName: string): string {
  const samples: Record<string, string> = {
    '{{primeiro_nome}}': 'Ana',
    '{{nome}}': 'Ana Souza',
    '{{loja}}': storeName.trim() || 'Sua loja',
    '{{pontos}}': '1.240',
  };
  return text.replace(/\{\{[a-z_]+\}\}/g, (token) => samples[token] ?? token);
}
